export const isMobileDevice = () => {
  if (navigator) {
    const ua = navigator.userAgent;
    if (/android/i.test(ua)) {
      return "Android";
    } else if (
      /iPad|iPhone|iPod/.test(ua) ||
      (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
    ) {
      return "iOS";
    } else if (/IEMobile/i.test(ua) || /Windows Phone/i.test(ua)) {
      return "Windows Phone";
    }
    if (navigator.userAgentData && navigator.userAgentData.mobile) {
      return true;
    }
    if (typeof window.orientation !== "undefined") {
      return true;
    }
  }
  return false;
};
